export default __webpack_public_path__ + "static/media/Obras.c65b1cb3.svg";